/**
 * @generated SignedSource<<52eef4c20b5a19e6129134a96f8b30c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Ordering = "ASC" | "ASC_NULLS_FIRST" | "ASC_NULLS_LAST" | "DESC" | "DESC_NULLS_FIRST" | "DESC_NULLS_LAST" | "%future added value";
export type MATUserInvoiceFilter = {
  AND?: MATUserInvoiceFilter | null;
  NOT?: MATUserInvoiceFilter | null;
  OR?: MATUserInvoiceFilter | null;
  distinct?: boolean | null;
  id?: string | null;
  id_Exact?: string | null;
  id_In?: ReadonlyArray<string> | null;
  id_Not_In?: ReadonlyArray<string> | null;
  isPaid?: boolean | null;
  userId_Exact?: string | null;
};
export type MATUserInvoiceOrder = {
  order_PaidAt?: Ordering | null;
};
export type MathKingUserId_userInvoicesQuery$variables = {
  after?: string | null;
  filters?: MATUserInvoiceFilter | null;
  first?: number | null;
  order?: MATUserInvoiceOrder | null;
};
export type MathKingUserId_userInvoicesQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UserInvoicePaginator_query">;
};
export type MathKingUserId_userInvoicesQuery = {
  response: MathKingUserId_userInvoicesQuery$data;
  variables: MathKingUserId_userInvoicesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MathKingUserId_userInvoicesQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "FragmentSpread",
        "name": "UserInvoicePaginator_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MathKingUserId_userInvoicesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "MATUserInvoiceConnection",
        "kind": "LinkedField",
        "name": "userInvoices",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MATUserInvoiceEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MATUserInvoice",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MATInternalProduct",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MATInternalItem",
                        "kind": "LinkedField",
                        "name": "item",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "premiumType",
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MATInternalOrder",
                    "kind": "LinkedField",
                    "name": "order",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "paidAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "amount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "applyStartDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "applyEndDate",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "filters": [
          "filters",
          "order"
        ],
        "handle": "connection",
        "key": "UserInvoicePaginator_query_userInvoices",
        "kind": "LinkedHandle",
        "name": "userInvoices"
      }
    ]
  },
  "params": {
    "cacheID": "6853aa275429eb4f7e599f43f8b74887",
    "id": null,
    "metadata": {},
    "name": "MathKingUserId_userInvoicesQuery",
    "operationKind": "query",
    "text": "query MathKingUserId_userInvoicesQuery(\n  $filters: MATUserInvoiceFilter\n  $order: MATUserInvoiceOrder\n  $first: Int\n  $after: String\n) {\n  ...UserInvoicePaginator_query_2rfEMg\n}\n\nfragment UserInvoiceConnectionDataTable_UserInvoiceConnection on MATUserInvoiceConnection {\n  edges {\n    node {\n      id\n      product {\n        name\n        item {\n          premiumType\n          id\n        }\n        id\n      }\n      order {\n        paidAt\n        amount\n        applyStartDate\n        applyEndDate\n        id\n      }\n    }\n  }\n}\n\nfragment UserInvoicePaginator_query_2rfEMg on Query {\n  userInvoices(filters: $filters, order: $order, first: $first, after: $after) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        id\n        product {\n          name\n          item {\n            premiumType\n            id\n          }\n          id\n        }\n        order {\n          paidAt\n          amount\n          applyStartDate\n          applyEndDate\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    ...UserInvoiceConnectionDataTable_UserInvoiceConnection\n  }\n}\n"
  }
};
})();

(node as any).hash = "e89b0fe2002bb274dd3dc86ef236c3d4";

export default node;
